module.exports = __webpack_public_path__ + "static/media/dribble-logo-button-2.951271ae.svg";